export default {
  placements: new Map([
    ['desktop-feed', true],
    ['mobile-feed', true],
    ['mobile-external', false],
    ['right-column', true],
    ['instagram-feed', false],
    ['instagram-story', false],
  ]),
  instagramSelected: false,
};
